import { createReducer } from '@reduxjs/toolkit';

import { loadProviderSettingsListSuccess, loadProviderSettingsStart } from './actions';
import { IProviderSettingsReducer } from './types';

const initialState: IProviderSettingsReducer = {
  isLoading: false,
  isLoaded: false,
  data: {},
};

const PayoutOrderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadProviderSettingsStart, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(loadProviderSettingsListSuccess, (state, action) => ({
      ...state,
      isLoading: false,
      isLoaded: true,
      data: action.payload,
    }));
});

export default PayoutOrderReducer;
